import styles from "@/components/common/styles/switcher.module.scss";

type SwitcherProps = {
  handleClick: () => void;
  isEnabled: boolean;
};

const Switcher = ({ handleClick, isEnabled }: SwitcherProps) => {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        handleClick();
      }}
      className={styles.switcher}
      style={{ backgroundColor: isEnabled ? "#FF5722FF" : "#3F3F3FFF" }}
    >
      <div
        className={styles.switcher_toggle}
        style={{ left: isEnabled ? "11px" : "3px" }}
      />
    </div>
  );
};

export default Switcher;
